import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!STRIPE_PUBLISHABLE_KEY) {
    throw new Error("Missing REACT_APP_STRIPE_PUBLIC_KEY in environment");
}

export const getStripe = () => {
    return loadStripe(STRIPE_PUBLISHABLE_KEY);
};
